import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import {Router} from '@angular/router';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private auth: AuthenticationService, private router: Router, private accountService: AccountService) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (next.data.roles){
      let user = this.accountService.getLocalAccount();
      if ((!user) || next.data.roles.indexOf(user.role.name) === -1){
        this.router.navigate(['login'], { state: { loginRedirect: encodeURI(state.url), authError: 'unauthorised_access' } });
        return false;
      }
    }

    if (this.auth.getToken()) {
      return true;
    } else {
      this.router.navigate(['login'], { state: { loginRedirect: encodeURI(state.url), authError: 'unauthorised_access' } });
      return false;
    }
  }
}
